let apiPromise;

export function loadHcaptcha() {
  if (apiPromise) return apiPromise;

  apiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const timeout = setTimeout(() => fail(), 30000);
    const fail = () => {
      clearTimeout(timeout);
      script.remove();
      delete window.universtageHcaptchaReady;
      apiPromise = null;
      reject(new Error('hCaptcha could not be loaded'));
    };

    // The onload callback runs after SDK setup, not just after the script downloads.
    window.universtageHcaptchaReady = () => {
      clearTimeout(timeout);
      resolve(window.hcaptcha);
    };
    script.src = 'https://js.hcaptcha.com/1/api.js?onload=universtageHcaptchaReady&render=explicit&recaptchacompat=off';
    script.async = true;
    script.defer = true;
    script.onerror = fail;
    document.head.appendChild(script);
  });

  return apiPromise;
}
